<template>
    <div class="story-maker-sticker-menu-music">
        <audio @canplaythrough="(e) => e.target.volume = '0.5'" ref="music-preview"></audio>
        <div class="header-menu">
            <p>{{ $t('dash.post-creator.story.music-title') }}</p>
        </div>
        <div class="search-bar">
            <i class="fa-regular fa-magnifying-glass"></i>
            <input :placeholder="$t('dash.post-creator.overlay.search-music')" v-model="models.search">
        </div>
        <div v-if="!models.search && feeds.length > 1" class="navigation">
            <div v-for="feed in feeds" :key="feed.id" @click="selectFeed(feed.id)" class="item-nav" :class="{active: selectedFeedId === feed.id}">{{ feed.name || $t('dash.post-creator.music.for-you') }}</div>
        </div>

        <div class="list-item hide-scrollbar">
            <span class="loader" v-if="stateLoader"></span>
            <p class="no-result" v-else-if="!list.length">{{ $t('dash.post-creator.overlay.no-result') }}</p>
            <div class="item" v-else v-for="(music,index) in list" @click="selectMusic(music)" :key="`music${index}`">
                <img :src="music.track.cover_artwork_thumbnail_uri">

                <div class="info">
                    <h5>{{ music.track.title }}</h5>
                    <p>{{ `${music.track.display_artist} • ${formatDuration(music.track.duration_in_ms)}` }}</p>
                </div>

                <div class="btn-control">
                    <div class="circle" @click.stop="toggleMusic(music)" :class="{play : urlMusicPlaying == music.track.progressive_download_url}">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import minxinPost from '@/components/mixins/Posts.vue'

    export default {
        mixins: [minxinPost],

        props: {
            dataStoryMakerDefault: Object,
            initialSearch: {
                type: String,
                default: null
            },
        },

        mounted() {
            if (this.initialSearch) {
                this.models.search = this.initialSearch
            }
        },

        beforeDestroy() {
            const audio = this.$refs['music-preview']
            if (audio) {
                audio.pause()
                audio.removeAttribute('src')
                audio.load()
            }
        },

        data() {
            return {
                models: {
                    search: ''
                },
                musics: [],
                selectedFeedId: null,
                stateLoader: false,
                timeoutInitSearch: null,
                urlMusicPlaying: null,
            }
        },

        methods: {
            formatDuration(ms) {
                return `${Math.floor((ms || 0) / 60000)}:${(('0' + Math.floor(((ms || 0) % 60000) / 1000)).slice(-2))}`
            },

            async searchMusic() {
                this.pauseMusic()
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = false
                if (!this.models.search) return
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p && p.network == 'facebook' && p.story_config && p.story_config.created)
                    this.musics = []
                    if (page) {
                        this.stateLoader = true
                        const res = await this.getMusicFacebook(page.id, this.models.search)
                        this.musics = (res && res.body && res.body.musics) || []
                    }
                    this.stateLoader = false
                }, 1000)
            },

            async selectMusic(music) {
                if (this.urlMusicPlaying) this.toggleMusic()
                this.$emit('addSticker', 'music', {
                    data: {
                        music,
                        styleVariant: 1,
                        rangeDuration: null,
                        start: (music.track.highlight_start_times_in_ms && music.track.highlight_start_times_in_ms[0]) || 0
                    }
                })
            },

            selectFeed(feedId) {
                this.selectedFeedId = feedId;
            },

            toggleMusic(music) {
                let audio = this.$refs['music-preview'];

                if (!music) {
                    this.urlMusicPlaying = null;
                    audio.pause();
                    return;
                }

                const track = music.track;

                if (track.progressive_download_url === audio.src) {
                    if (audio.paused) {
                        audio.play();
                        this.urlMusicPlaying = track.progressive_download_url;
                    } else {
                        audio.pause();
                        this.urlMusicPlaying = null;
                    }
                } else {
                    audio.src = track.progressive_download_url;
                    audio.currentTime = ((track.highlight_start_times_in_ms && track.highlight_start_times_in_ms[0]) || 0) / 1000;
                    this.urlMusicPlaying = track.progressive_download_url;
                    audio.play();
                }
            },

            pauseMusic() {
                let audio = this.$refs['music-preview'];
                if (!audio) return
                audio.pause();
                this.urlMusicPlaying = null;
            }
        },

        watch: {
            ['models.search']() {
                this.searchMusic()
            },

            feeds: {
                immediate: true,
                handler(newValue) {
                    if (!this.selectedFeedId && newValue && newValue.length) {
                        this.selectedFeedId = newValue[0].id
                    }
                }
            },
        },

        computed: {
            feeds() {
                return (this.dataStoryMakerDefault && this.dataStoryMakerDefault.musicsFacebook) || []
            },

            selectedFeed() {
                return this.feeds.find(f => f.id === this.selectedFeedId) || this.feeds[0] || null
            },

            list() {
                if (this.models.search.length) return this.musics
                return this.selectedFeed ? this.selectedFeed.musics : []
            },

            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>
